import { Box, BoxProps } from "@chakra-ui/react";
import { NotesGetFilters } from "common";
import { useAPI } from "../api/useAPI";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { InfiniteScrollBottom } from "../utils/InfiniteScrollBottom";
import { useInfiniteAPIQuery } from "../utils/useInfiniteAPIQuery";
import { NoteCard } from "./NoteCard";
import { AiFillSmile } from "react-icons/ai";

interface NotesListProps extends BoxProps {
  queryParams?: NotesGetFilters;
}

export const NotesList = ({ queryParams = {}, ...props }: NotesListProps) => {
  const api = useAPI();
  const { items, onBottomReached, isEnd, error } = useInfiniteAPIQuery({
    apiCall: api.noteGet,
    transformer: (result) => result.notes,
    queryParams: queryParams,
    itemsPerPage: 7,
    idField: "id",
    sortField: "createTime",
    sortOrder: "DESC",
  });
  useToastOnAPIError({ error, title: "Unable to fetch notes" });

  return (
    <Box display={"flex"} flexDir={"column"} width={"100%"} {...props}>
      {items.map((item) => (
        <NoteCard key={item.id} note={item} marginBottom={4} />
      ))}
      {isEnd ? (
        <Box
          textAlign={"center"}
          fontWeight={"bold"}
          display={"flex"}
          flexDir={"column"}
          alignItems={"center"}
        >
          <AiFillSmile size={70} />
          No more Activity
        </Box>
      ) : null}
      <InfiniteScrollBottom onBottomReached={onBottomReached} isEnd={isEnd} />
    </Box>
  );
};
